import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import RenterList from "../../components/Renter/RenterListLayer";


const RenterListPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Renter" />

        {/* UsersListLayer */}
        <RenterList />

      </MasterLayout>

    </>
  );
};

export default RenterListPage; 
